import React, { Component } from 'react';

import './Navigation.css';

import Arrow from '../assets/img/arrow.png';

class Navigation extends Component {
  render() {
    return(
      <div className='navigation'>
        <button className='proceed_button' onClick={this.props.onClickButton}>{this.props.text} <img src={Arrow} alt='' /></button>
        <nav>
          {[...Array(6)].map((x, i) =>
            <span key={i} className={`circle ${this.props.active === i ? 'active' : ''}`} onClick={() => this.props.onClickNav(i) }></span>
          )}
        </nav>
      </div>
    )
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.jsx